import React from "react";
import { Card, Button } from "react-bootstrap";
import { ActionHandlerFunction, UserProfile } from "@preveil-api";
import { AdminUIActionTypes } from "src/common";

type AllProps = {
  approver: UserProfile;
  handleAction: ActionHandlerFunction;
}

// Description: This component is used to display the instructions to the user to approve the data export request.
function AwaitConnectionComponent(props: AllProps) {
  const { approver, handleAction } = props;

  return <Card className="pv-card">
    <Card.Body>
      <h4 className="content-header">
        <i className="waiting"></i>Awaiting Connection&hellip;
      </h4>
        <p className="fs-3">Contact <strong>{`${approver?.name}[${approver?.address}]`}</strong> and ask them to:</p>
        <ol>
          <li><p>Access their PreVeil account on a computer</p></li>
          <li><p>Click on Settings then Approvals</p></li>
          <li><p>Click on the Data Export approval item and start the approval</p></li>
          <li><p>Enter your PreVeil ID (your email address)</p></li>
          <li><p>Provide the code that will appear on this screen</p></li>
        </ol>
      <Button variant="outline-secondary" onClick={() => handleAction({ actionType: AdminUIActionTypes.Reset })}>Back</Button>
    </Card.Body>
  </Card>;
}

export default React.memo(AwaitConnectionComponent);